import { render } from "./studentWeeklyAttendance.vue?vue&type=template&id=13c92210&scoped=true"
import script from "./studentWeeklyAttendance.vue?vue&type=script&lang=js"
export * from "./studentWeeklyAttendance.vue?vue&type=script&lang=js"

import "./studentWeeklyAttendance.vue?vue&type=style&index=0&id=13c92210&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c92210"]])

export default __exports__